export default class DomainSwitcher {

    constructor(trigger) {
        this.trigger = trigger;
        this.modalTitle = trigger.dataset.domainSwitcherModalTitle;

        this.trigger.addEventListener('click', () => this.openModal());
    }

    openModal() {
        const template = document.querySelector('[data-domain-switcher-manual-template]');

        if (template === null) {
            return;
        }

        new window.aui.modal({
            title: this.modalTitle,
            class: 'aui-domain-switcher-modal',
            body: template.innerHTML,
            type: 'sm',
        });
    }

    static init(container) {
        container.querySelectorAll('[data-domain-switcher-manual-trigger]').forEach((trigger) => {
            new DomainSwitcher(trigger);
        });
    }

}

naja.addEventListener('init', () => {
    DomainSwitcher.init(document.body);
});
